import script from "./CartWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CartWidget.vue?vue&type=script&setup=true&lang=js"

import "./CartWidget.vue?vue&type=style&index=0&id=6cb70c2c&lang=css"

const __exports__ = script;

export default __exports__